import React, { ReactNode } from 'react';
import clsx from 'clsx';

import noDataPlaceholder from './no-data-placeholder.svg';
import * as styles from './no-data-splash-screen.scss';

interface NoDataSplashScreenProps {
  title?: ReactNode;
  description?: ReactNode;
  extraContent?: ReactNode;
  transparent?: boolean;
}

export const NoDataSplashScreen = ({ title, description, extraContent, transparent }: NoDataSplashScreenProps) => {
  return (
    <div className={clsx(styles.container, { [styles.transparent]: transparent })}>
      <img src={noDataPlaceholder} alt="no-data-placeholder" />
      {title && <div className={styles.title}>{title}</div>}
      {description && <div className={styles.description}>{description}</div>}
      {extraContent && <div className={styles.extraContent}>{extraContent}</div>}
    </div>
  );
};
